module.exports = __webpack_public_path__ + "img/gall-7.c3885c20.jpg";